import { isBoolean } from "lodash";

import { getHumanReadableNameCellHelper } from "../../../../../../../utils";

import type { Order } from "../../../../../../../services";
import type Language from "../../../../../../../services/Language";

const cellProcessing = (item: Order.Model, language: Language) => {
	const isOwn = isBoolean(item?.isOwn) ? item.isOwn : true;

	const transfer = item?.additionalFields?.transfer;
	const fromTaxiService = transfer?.lastReceivedOrder?.taxiService;
	const transferHasExecutor =
		transfer?.lastReceivedOrder?.executorToOrder?.length;

	let executor;
	if (item?.executorToOrder?.length) {
		executor = item.executorToOrder[0]?.executor;
	} else if (
		item?.additionalFields?.transfer?.lastReceivedOrder?.executorToOrder
			?.length
	) {
		executor =
			item.additionalFields.transfer.lastReceivedOrder
				.executorToOrder?.[0]?.executor;
	} else {
		executor = item?.offer?.executor;
	}

	const settlement = getHumanReadableNameCellHelper(
		executor?.taxiService?.settlement,
		language,
	);
	const company = getHumanReadableNameCellHelper(
		executor?.taxiService?.company?.name,
		language,
	);

	let content = "";

	if ((isOwn && !transferHasExecutor) || !fromTaxiService || !executor) {
		content = "";
	} else if (!settlement && company) {
		content = company;
	} else {
		content = `${company} (${settlement})`;
	}

	return {
		content,
	};
};

export default cellProcessing;
